module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_an@2x-b8c59a4272ef46cbf80de735a0806b84.webp";